
import { useState } from "react";

export default function Home() {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleRegisterClick = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center min-h-screen flex items-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/232def46889ed6e180917c953f181bca.jpg')`,
        }}
      >
        <div className="absolute inset-0 bg-white/70"></div>

        {/* Logo */}
        <div className="absolute top-2 left-2 z-20">
          <img
            src="https://static.readdy.ai/image/482db82fa6135662cb175aa58592a390/0f90afccf080785d3f48ab4b9d5a5a73.png"
            alt="8028 Private Salon"
            className="h-8 w-auto"
          />
        </div>

        <div className="relative z-10 w-full">
          <div className="container mx-auto px-6 lg:px-20">
            <div className="max-w-2xl">
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-6 leading-tight">
                歯の健康を守るプロと、<br />
                あなたをつなぐ新しい仕組み
              </h1>
              <p className="text-xl text-gray-700 mb-8 leading-relaxed">
                8028サロンは、メンテナンスができる歯科衛生士と患者をつなぐオンラインプラットフォームです
              </p>
              <button
                onClick={handleRegisterClick}
                className="bg-[#EF9786] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#e8856f] transition-colors cursor-pointer whitespace-nowrap"
              >
                今すぐ無料登録
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 lg:px-20">
          <h2 className="text-3xl font-bold text-center mb-12">
            <span className="text-[#EF9786]">なぜ8028サロンが生まれたのか？</span>
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-lg shadow-sm">
                <div className="w-16 h-16 bg-[#EF9786]/10 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-calendar-line text-2xl text-[#EF9786]"></i>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  定期的な歯のメンテナンスの重要性は分かっていても、継続が難しい
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-sm">
                <div className="w-16 h-16 bg-[#EF9786]/10 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-time-line text-2xl text-[#EF9786]"></i>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  歯科医院に通う時間が取りにくい
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-sm">
                <div className="w-16 h-16 bg-[#EF9786]/10 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-heart-line text-2xl text-[#EF9786]"></i>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  信頼できる衛生士に、長く寄り添ってほしい
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Overview */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 lg:px-20">
          <h2 className="text-3xl font-bold text-center mb-12">
            <span className="text-[#EF9786]">8028サロンが解決します</span>
          </h2>
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-3 gap-12">
              <div className="text-center">
                <div className="w-20 h-20 bg-[#EF9786] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-team-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold mb-4 text-gray-800">つながる</h3>
                <p className="text-gray-600 leading-relaxed">
                  地域や条件に合わせて希望に合う歯科衛生士をマッチング
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-[#EF9786] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-refresh-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold mb-4 text-gray-800">続けられる</h3>
                <p className="text-gray-600 leading-relaxed">
                  オンライン予約・管理で無理なく定期的にメンテナンス
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-[#EF9786] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-book-open-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold mb-4 text-gray-800">学べる</h3>
                <p className="text-gray-600 leading-relaxed">
                  歯の健康情報やセルフケアを学べるコンテンツ
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How it Works */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 lg:px-20">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">利用の流れ</h2>
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#EF9786] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">1</span>
                </div>
                <h3 className="font-bold mb-2 text-gray-800">患者登録</h3>
                <p className="text-sm text-gray-600">希望条件や住んでいる地域を入力</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-[#EF9786] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">2</span>
                </div>
                <h3 className="font-bold mb-2 text-gray-800">自動提案</h3>
                <p className="text-sm text-gray-600">条件に合う歯科衛生士を自動提案</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-[#EF9786] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">3</span>
                </div>
                <h3 className="font-bold mb-2 text-gray-800">面談・予約</h3>
                <p className="text-sm text-gray-600">オンライン面談・予約</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-[#EF9786] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">4</span>
                </div>
                <h3 className="font-bold mb-2 text-gray-800">メンテナンス開始</h3>
                <p className="text-sm text-gray-600">定期メンテナンススタート</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 lg:px-20">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-16">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl">
                <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-user-heart-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold mb-4 text-gray-800">患者にとって</h3>
                <p className="text-gray-700 leading-relaxed">
                  信頼できる衛生士と長期的な関係を築ける
                </p>
              </div>
              <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-xl">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-shield-user-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold mb-4 text-gray-800">衛生士にとって</h3>
                <p className="text-gray-700 leading-relaxed">
                  医院勤務以外でも、自分らしく働ける場ができる
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 lg:px-20">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">ユーザーの声</h2>
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white p-8 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <img
                    src="https://readdy.ai/api/search-image?query=Happy%20middle%20aged%20Japanese%20woman%20smiling%20warmly%2C%20professional%20headshot%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20natural%20lighting%2C%20medical%20patient%20portrait&width=80&height=80&seq=patient1&orientation=squarish"
                    alt="患者"
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h4 className="font-bold text-gray-800">田中さん（患者）</h4>
                    <div className="flex text-yellow-400">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic">
                  「定期的に見てもらえる安心感が違います。自分に合った衛生士さんと出会えて本当に良かったです。」
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20dental%20hygienist%20woman%20smiling%20confidently%2C%20medical%20uniform%2C%20clean%20white%20background%2C%20healthcare%20professional%20portrait%2C%20friendly%20and%20trustworthy%20expression&width=80&height=80&seq=hygienist1&orientation=squarish"
                    alt="歯科衛生士"
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h4 className="font-bold text-gray-800">佐藤さん（歯科衛生士）</h4>
                    <div className="flex text-yellow-400">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic">
                  「医院勤務だけでは出会えなかった患者さんとつながれました。やりがいを感じています。」
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 lg:px-20">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">料金プラン</h2>
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl text-center">
                <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-user-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-800">患者</h3>
                <div className="mb-6">
                  <span className="text-3xl font-bold text-blue-600">無料</span>
                  <span className="text-gray-600">/基本登録</span>
                </div>
                <p className="text-gray-700 mb-4">メンテナンス費用は都度払い or 定額プラン</p>
                <ul className="text-sm text-gray-600 text-left space-y-2">
                  <li className="flex items-center">
                    <i className="ri-check-line text-blue-500 mr-2"></i>衛生士マッチング
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-blue-500 mr-2"></i>オンライン予約
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-blue-500 mr-2"></i>健康情報配信
                  </li>
                </ul>
              </div>
              <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-xl text-center">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-user-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-800">歯科衛生士</h3>
                <div className="mb-6">
                  <span className="text-3xl font-bold text-green-600">無料</span>
                  <span className="text-gray-600">/登録</span>
                </div>
                <p className="text-gray-700 mb-4">マッチング成立時に手数料発生</p>
                <ul className="text-sm text-gray-600 text-left space-y-2">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>患者マッチング
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-5

                    mr-2"></i>スケジュール管理
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>収益管理ツール
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-[#EF9786]/10 to-[#EF9786]/5">
        <div className="container mx-auto px-6 lg:px-20 text-center">
          <h2 className="text-3xl font-bold mb-6 text-gray-800">
            あなたの歯の健康を、<br />
            一緒に守るパートナーを見つけましょう
          </h2>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            8028サロンで信頼できる歯科衛生士と出会い、継続的な口腔ケアを始めませんか？
          </p>
          <button
            onClick={handleRegisterClick}
            className="bg-[#EF9786] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#e8856f] transition-colors cursor-pointer whitespace-nowrap shadow-lg"
          >
            8028サロンに登録する
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6 lg:px-20">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div>
                <img
                  src="https://static.readdy.ai/image/482db82fa6135662cb175aa58592a390/0f90afccf080785d3f48ab4b9d5a5a73.png"
                  alt="8028 Private Salon"
                  className="h-6 w-auto mb-4"
                />
                <p className="text-gray-400 mb-4">
                  歯の健康を守るプロと患者をつなぐプラットフォーム
                </p>
              </div>
            </div>
            <div>
              <h4 className="font-bold mb-4">会社情報</h4>
              <div className="space-y-2 text-gray-400">
                <p>運営会社：8028Global Inc</p>
                <p>お問い合わせ：support@8028private.com</p>
                <p>
                  Webサイト：
                  <a
                    href="https://8028private.com"
                    className="hover:text-white transition-colors"
                  >
                    https://8028private.com
                  </a>
                </p>
              </div>
            </div>
            <div>
              <h4 className="font-bold mb-4">リンク</h4>
              <div className="space-y-2">
                <div>
                  <a
                    href="/terms"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    利用規約
                  </a>
                </div>
                <div>
                  <a
                    href="/privacy"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    プライバシーポリシー
                  </a>
                </div>
                <div>
                  <a
                    href="/legal"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    特定商取引法に基づく表示
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 8028Global Inc. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Registration Modal */}
      {isModalVisible && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-8 max-w-md w-full">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#EF9786] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-add-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-800">
                登録受付開始まで<br />
                もう少しお待ちください
              </h3>
              <p className="text-gray-600 mb-6">
                8028サロンは現在開発中です。サービス開始時にお知らせいたします。
              </p>
              <button
                onClick={closeModal}
                className="bg-[#EF9786] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#e8856f] transition-colors cursor-pointer whitespace-nowrap"
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
